import { Component, inject } from '@angular/core'
import { UserService } from '../../services/user.service'
import { environment } from '../../../environments/environment'
import { Subject } from 'rxjs'
import { debounceTime } from 'rxjs/operators'
import { CommonModule } from '@angular/common'
import { FormsModule } from '@angular/forms'
import { PaginationComponent } from '../template/pagination/pagination.component'

@Component({
  selector: 'app-anniversary',
  imports: [CommonModule, FormsModule, PaginationComponent],
  templateUrl: './anniversary.component.html',
  styleUrl: './anniversary.component.scss'
})
export class AnniversaryComponent {
  anniversaryList: any[] = []
  search = ''
  pageLimit = 10
  currentPage = 1
  totalCount = 0
  public apiEndpoint = environment.apiBaseUrl
  private userService = inject(UserService)
  private searchSubject = new Subject<string>()

  get pageLastRecord(): number {
    return Math.min(this.currentPage * this.pageLimit, this.totalCount)
  }

  ngOnInit() {
    this.loadAnniversaries()
    this.searchSubject.pipe(debounceTime(400)).subscribe(() => {
      this.currentPage = 1
      this.loadAnniversaries()
    })
  }

  loadAnniversaries() {
    const params = {
      page: this.currentPage,
      limit: this.pageLimit,
      search: this.search?.trim() || undefined,
      type: 'anniversary' as const
    }

    this.userService.getCelebrations(params).subscribe((res: any) => {
      if (res.type === 'all') {
        this.anniversaryList = res.data || []
        this.totalCount = res.total || 0
      }
    })
  }

  onFilterChange() {
    this.searchSubject.next(this.search)
  }

  onPageChange(page: number) {
    this.currentPage = page
    this.loadAnniversaries()
  }

  sendWish(userId: string) {
    console.log('Send anniversary wish to', userId)
  }
  getCompletedYears(emp: any): number {
    const today = new Date()
    const joiningDate = new Date(emp.joiningDate)

    let years = today.getFullYear() - joiningDate.getFullYear()

    const hasHappenedThisYear =
      today.getMonth() > joiningDate.getMonth() ||
      (today.getMonth() === joiningDate.getMonth() && today.getDate() >= joiningDate.getDate())

    if (!hasHappenedThisYear) {
      years -= 1
    }

    if (years < 0) {
      return 1
    }

    return years + 1
  }

  isTodayCelebration(emp: any, type: 'anniversary' | 'birthday' = 'anniversary'): boolean {
    const dateStr = type === 'anniversary' ? emp.joiningDate : emp.birthdate
    if (!dateStr) return false

    const today = new Date()
    const date = new Date(dateStr)

    return today.getDate() === date.getDate() && today.getMonth() === date.getMonth()
  }
}
